<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
      <div class='container-fluid'>
          <div class='col-lg-12' style='padding:0px'>
            <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
              <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
              </ul>
            </div>
            <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
               {{success}}
            </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>المنتج:</label>
                    <select  @change='GetPrice($event)' class="form-control" style="padding: 0px" v-model="record.item_id">
                      <option v-for="contractItem in contractItems" v-bind:key="contractItem.id" v-bind:value="contractItem.id">
                        {{ contractItem.item }}
                      </option>
                    </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>تاريخ العقد:</label>
                    <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.contract_date'></Datepicker>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>تاريخ التركيب:</label>
                    <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.installtion_date'></Datepicker>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                  <div class='col-lg-6 col-md-6 col-sm-6' style='padding:0px 0px 0px 3px;'>
                    <label>حالة العقد:</label>
                    <select class="form-control" style="padding: 0px" v-model="record.status">
                      <option v-for="item in status" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class='col-lg-6 col-md-6 col-sm-6' style='padding:0px;'>
                      <label>حالة المنتج:</label>
                      <select  @change='GetPrice($event)' class="form-control" style="padding: 0px" v-model="record.item_type">
                        <option v-for="type in item_price_types" v-bind:key="type.id" v-bind:value="type.id">
                          {{ type.name }}
                        </option>
                      </select>
                  </div>                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>المفوض:</label>
                    <select class="form-control" style="padding: 0px" v-model="record.delegate_id">
                      <option v-for="delegate in delegates" v-bind:key="delegate.id" v-bind:value="delegate.id">
                        {{ delegate.name }}
                      </option>
                    </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>الفنى:</label>
                    <select class="form-control" style="padding: 0px" v-model="record.technical_id">
                      <option v-for="technical in technicals" v-bind:key="technical.id" v-bind:value="technical.id">
                        {{ technical.name }}
                      </option>
                    </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>الخزنة:</label>
                    <select class="form-control" style="padding: 0px" v-model="record.treasury_id">
                      <option v-for="treasury in treasuries" v-bind:key="treasury.id" v-bind:value="treasury.id">
                        {{ treasury.name }}
                      </option>
                    </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>المخزن:</label>
                    <select class="form-control" style="padding: 0px" v-model="record.store_id">
                      <option v-for="store in stores" v-bind:key="store.id" v-bind:value="store.id">
                        {{ store.name }}
                      </option>
                    </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                  <label>طريقة الدفع:</label>
                  <select class="form-control" style="padding: 0px" v-model="record.payment_type">
                    <option v-for="type in paymentTypes" v-bind:key="type.id" v-bind:value="type.id">
                      {{ type.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-1 col-md-1 col-sm-6' style='padding:5px;'>
                    <label>السعر:</label>
                    <input  @keypress="isNumber($event)"  v-model='record.price' class='form-control' name='price' type='text'>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-6' style='padding:5px;'>
                    <label>م التركيب:</label>
                    <input  @keypress="isNumber($event)"  v-model='record.installation_fee' class='form-control' name='installation_fee' type='text'>
                </div>
                <div class='col-lg-1 col-md-1 col-sm-6' style='padding:5px;'>
                    <label>الخصم:</label>
                    <input  @keypress="isNumber($event)"  v-model='record.discount' class='form-control' name='discount' type='text'>
                </div>
                <div class='col-lg-1 col-md-1 col-sm-6' style='padding:5px;'>
                    <label>المطلوب:</label>
                    <input  @keypress="isLocked($event)"  v-model='record.amount' class='form-control' name='amount' type='text'>
                </div>
                <div class='col-lg-1 col-md-1 col-sm-6' style='padding:5px;'>
                    <label>المقدم:</label>
                    <input  @keypress="isNumber($event)"  v-model='record.presenter' class='form-control' name='presenter' type='text'>
                </div>
                <div class='col-lg-1 col-md-1 col-sm-6' style='padding:5px;'>
                    <label>الباقى:</label>
                    <input  @keypress="isLocked($event)" v-model='record.rest' class='form-control' name='rest' type='text'>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-6' style='padding:5px;'>
                  <label>ت سداد المقدم:</label>
                  <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.presenter_date'></Datepicker>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>قسط مخصص:</label>
                    <input :disabled="record.id > 0" @keypress="isNumber($event)"  v-model='record.custom_premium' class='form-control' name='presenter' type='text'>
                </div>
                <div class='col-lg-4 col-md-4 col-sm-6' style='padding:5px;'>
                    <label>طريقة سداد القسط المخصص:</label>
                    <select :disabled="record.id > 0" class="form-control" style="padding: 0px" v-model="record.custom_premium_type">
                      <option v-for="item in custom_premium_types" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-6' style='padding:5px;'>
                  <tbDate :disabled="record.id > 0" :mytitle='customPremiumDateTitle' v-model= 'record.custom_premium_date' ></tbDate>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>إجمالى قيمة الأقساط:</label>
                    <input @keypress="isNumber($event)" v-model='record.total_premiums' class='form-control' name='total_premiums' type='text'>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>عدد الأقساط:</label>
                    <input  @keypress="isNumber($event)"  :disabled="record.id > 0" v-model='record.instal_count' class='form-control' name='instal_count' type='text'>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-6' style='padding:5px;'>
                    <label>قيمة القسط:</label>
                    <input @keypress="isNumber($event)" v-model='record.instal_amount' class='form-control' name='instal_amount' type='text'>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-6' style='padding:5px;'>
                    <label>بداية السداد:</label>
                    <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.instal_start'></Datepicker>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-6' style='padding:5px;'>
                    <label>نوع العقد:</label>
                    <select class="form-control" style="padding: 0px" v-model="record.contract_type">
                      <option v-for="type in types" v-bind:key="type.id" v-bind:value="type.id">
                        {{ type.name }}
                      </option>
                    </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-4' style='padding:5px;'>
                    <label>بداية عقد الصيانة:</label>
                    <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.maintenance_date'></Datepicker>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>عرض الشمع المجانى:</label>
                    <select class="form-control" style="padding: 0px" v-model="record.free_offer_id">
                      <option v-for="type in free_offers" v-bind:key="type.id" v-bind:value="type.id">
                        {{ type.offer_name }}
                      </option>
                    </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>مجموعة تغيير الشمع:</label>
                    <select class="form-control" style="padding: 0px" v-model="record.maintenance_group_id">
                      <option v-for="type in maintenanceGroups" v-bind:key="type.id" v-bind:value="type.id">
                        {{ type.group_name }}
                      </option>
                    </select>
                </div>
                <div class='col-lg-6  col-md-6 col-sm-12' style='padding:5px;'>
                    <label>ملاحظات:</label>
                    <input v-model='record.nots' class='form-control' name='nots' type='text'>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>م أقساط</label>
                    <input disabled :value='record.indebtedness' class='form-control' name='instal_count' type='text'>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>م صيانة</label>
                    <input disabled :value='record.maintenance_ind' class='form-control' name='instal_count' type='text'>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>م عروض</label>
                    <input disabled :value='record.offer_balance' class='form-control' name='instal_count' type='text'>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style='padding:5px;'>
                    <label>الاجمالى</label>
                    <input disabled :value='record.indebtedness + record.maintenance_ind' class='form-control' name='instal_count' type='text'>
                </div>
                <div class='col-lg-12 col-sm-12' style='direction: ltr;padding: 0px;margin:0px'>
                  <h6 style='padding: 0px;margin:0px'>
                    <code v-show="record.createdat">
                     created at: {{record.createdat}}           ||           updated at: {{record.updatedat}} </code>
                  </h6>
                </div>
                <!-- <div class='col-lg-12 col-sm-12' style='padding:10px;text-align: center;'>
                  <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                  <button v-show="($per.value.saveContract && record.id === 0 ) || ($per.value.editContract && record.id > 0 )" @click='saveData()'  type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
                  <button v-show="$per.value.deleteContract && record.id > 0"  @click='deleteData(selectedrec)' type='button' class='btn btn-outline btn-danger btn-sm'>حذف</button>
                </div> -->
              </div>
          <!-- /.col-lg-12 -->

       </div>
    <!-- /.container-fluid -->
</div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
import Datepicker from 'vuejs-datepicker'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import Swal from 'sweetalert2'
export default {
  components: {
    tbDate,
    Datepicker
  },
  name: 'contract',
  data () {
    return {
      dateContractTitle: 'تاريخ العقد',
      dateInstallationTitle: 'تاريخ التركيب',
      dateMaintanenceTitle: 'بداية عقد الصيانة',
      customPremiumDateTitle: 'ت سداد مخصص',
      ar: ar,
      validationErrors: '',
      records: {},
      record: {},
      total: 0,
      isDisabled: false,
      treasuries: {},
      technicals: {},
      delegates: {},
      free_offers: {},
      stores: {},
      maintenanceGroups: {},
      emptyRec: [{id: 0, name: ''}],
      paymentTypes: [{id: 1, name: 'كاش'}, {id: 2, name: 'قسط'}],
      item_price_types: [{id: 0, name: 'جديد'}, {id: 1, name: 'مستعمل'}],
      custom_premium_types: [{id: 1, name: 'السداد مع أول قسط'}, {id: 2, name: 'السداد مع آخر قسط'}, {id: 3, name: 'السداد فى تاريخ مخصص'}],
      types: [{id: 1, name: 'عقد بيع وصيانة'}, {id: 2, name: 'عقد بيع'}, {id: 3, name: 'عقد صيانة'}],
      status: [{id: 1, name: 'نشط'}, {id: 0, name: 'غير نشط'}, {id: 2, name: 'ممتنع'}, {id: 3, name: 'قضية'}, {id: 4, name: 'مرتجع'}],
      items: {},
      branches: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      selectedrec: null,
      maintenancesdisabled: true
    }
  },
  mounted: function () {
    this.$watch('record', function () {
      this.record.amount = (parseInt(this.record.installation_fee || 0) + parseInt(this.record.price || 0)) - parseInt(this.record.discount || 0)
      this.record.rest = parseInt(this.record.amount || 0) - parseInt(this.record.presenter || 0)
      this.record.total_premiums = parseInt(this.record.rest || 0) - parseInt(this.record.custom_premium || 0) || 0
      if (this.record.custom_premium === 0 || this.record.custom_premium === null || this.record.custom_premium === '') {
        this.record.custom_premium_type = ''
        this.record.custom_premium_date = ''
      }
    }, {deep: true})
  },
  computed: {
    contractItems () {
      if (this.items.lenght === 0) {
        return []
      } else {
        return this.items.filter(item => parseInt(item.is_contract) === 1)
      }
    }
  },
  methods: {
    tabSelected () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-free_offers', {
        token: localStorage.getItem('token'),
        branch_id: this.$store.state.customerData.branche_id
      })
        .then(res => {
          this.free_offers = res.data
        })
        // --------------------------------------
      axios.post(this.$apiURL + 'get-branch-item-prices', {
        token: localStorage.getItem('token'),
        branch: this.$store.state.customerData.branche_id
      })
        .then(res => {
          this.items = res.data
        })
      this.isLoadingData = false
      this.showForm(this.$store.state.customerData.contract[0])
    },
    // ============================================================
    UpdateData (id) {
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      let i = this.branches.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.treasuries = this.branches[i].treasuries
        this.stores = this.branches[i].stores
        this.technicals = this.branches[i].technicals
        this.delegates = this.branches[i].delegates
        this.technicals.unshift(this.emptyRec)
      }
    },
    // =====================================================
    GetPrice (event) {
      this.GetMaintenanceGroups()
      let i = this.items.findIndex(x => x.id === parseInt(event.target.value))
      if (i > -1) {
        this.record.price = this.items[i].price
      } else {
        this.record.price = 0
      }
    },
    // =====================================================
    GetMaintenanceGroups () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'GetMaintenanceGroups', {
        token: localStorage.getItem('token'),
        branche_id: this.$store.state.customerData.branche_id,
        product_id: this.record.item_id
      })
        .then(({ data }) => {
          this.maintenanceGroups = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    updateTotal (id, ind, mai) {
      let i = this.records.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.records[i].indebtedness = ind
        this.records[i].maintenance_ind = mai
      }
    },
    GetData () {
      this.errorShow = false
      this.successShow = false
      this.isLoadingSave = false
      // -----------------------------------------------------
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      this.UpdateData(this.$store.state.customerData.branche_id)
      // -----------------------------------------------------
      this.records = this.$store.state.customerData.contract
      if (typeof (this.records) === 'undefined') {
        this.records = []
      }
      this.showForm(0)
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    isLocked: function (evt) {
      evt.preventDefault()
    },
    showForm (recID) {
      this.successShow = false
      this.errorShow = false
      this.isDisabled = false
      this.error = ''
      if (recID === 0) {
        this.selectedrec = 0
        this.isDisabled = true
        this.record = {
          'id': 0,
          'item_id': '',
          'customer_id': '',
          'delegate_id': '',
          'technical_id': '',
          'contract_date': '',
          'installtion_date': '',
          'maintenance_date': '',
          'amount': 0,
          'discount': 0,
          'installation_fee': 0,
          'presenter': 0,
          'rest': 0,
          'treasury_id': '',
          'store_id': '',
          'instal_count': '',
          'instal_amount': '',
          'instal_start': '',
          'custom_premium': '',
          'custom_premium_type': '',
          'custom_premium_date': '',
          'presenter_date': '',
          'total_premiums': '',
          'user_id': '',
          'nots': '',
          'contract_type': '',
          'status': 1,
          'freeitems': 0,
          'free_offers': null,
          'maintenance_group_id': '',
          'payment_type': null,
          'item_type': 0}
      } else {
        this.selectedrec = recID.id
        this.record = recID
        this.GetMaintenanceGroups()
      }
      if (this.record.maintenance_date === null || this.record.maintenance_date === '' || this.record.contract_type === '2') {
        this.maintenancesdisabled = true
      } else {
        this.maintenancesdisabled = false
      }
    },
    saveData () {
      this.validationErrors = ''
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveContract', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        item_id: this.record.item_id,
        customer_id: this.$store.state.customerData.id,
        delegate_id: this.record.delegate_id,
        technical_id: this.record.technical_id,
        contract_date: this.record.contract_date,
        installtion_date: this.record.installtion_date,
        maintenance_date: this.record.maintenance_date,
        amount: this.record.amount,
        price: this.record.price,
        discount: parseInt(this.record.discount || 0),
        installation_fee: this.record.installation_fee,
        presenter_date: this.record.presenter_date,
        presenter: this.record.presenter,
        rest: this.record.rest,
        treasury_id: this.record.treasury_id,
        store_id: this.record.store_id,
        contract_type: this.record.contract_type,
        instal_count: this.record.instal_count,
        instal_amount: this.record.instal_amount,
        instal_start: this.record.instal_start,
        custom_premium: this.record.custom_premium,
        custom_premium_type: this.record.custom_premium_type,
        custom_premium_date: this.record.custom_premium_date,
        total_premiums: this.record.total_premiums,
        item_type: this.record.item_type,
        user_id: this.record.user_id,
        nots: this.record.nots,
        payment_type: this.record.payment_type,
        freeitems: this.record.freeitems,
        free_offers: this.record.free_offer_id,
        status: this.record.status,
        maintenance_group_id: this.record.maintenance_group_id
      })
        .then(res => {
          this.$root.$emit('Update_Totals', this.$store.state.customerData.id, res.data.totals[0].ind, res.data.totals[0].mai, res.data.totals[0].total, res.data.data[0].contract_id, res.data.totals[0].balance)
          this.record.createdat = res.data.data[0].created_at
          this.record.updatedat = res.data.data[0].updated_at
          if (this.record.id === 0) {
            this.record.id = res.data.data[0].id
            this.records.push(res.data.data[0])
            this.selectedrec = res.data.data[0].id
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data.data[0])
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
          if (this.record.maintenance_date === null || this.record.maintenance_date === '' || this.record.contract_type === '2') {
            this.maintenancesdisabled = true
          } else {
            this.maintenancesdisabled = false
          }
          this.$root.$emit('RefrishAllCustomerData', this.$store.state.customerData.uid)
          this.isLoadingSave = false
          this.isDisabled = false
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا السجل نهائيا من قاعدة البيانات!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      })
        .then((result) => {
          if (result.isConfirmed) {
            this.isLoadingSave = true
            axios.post(this.$apiURL + 'deleteContract', {
              token: localStorage.getItem('token'),
              customer_id: this.$store.state.customerData.id,
              id: recID
            })
              .then(res => {
                Swal.fire({
                  position: 'fixed',
                  icon: 'success',
                  title: 'تم حذف السجل بنجاح',
                  showConfirmButton: false,
                  timer: 1000
                })
                this.$root.$emit('Update_Totals', this.$store.state.customerData.id, 0, 0, 0, this.record.id, res.data.totals[0].balance)
                let i = this.records.map(record => record.id).indexOf(recID)
                this.records.splice(i, 1)
                this.isLoadingSave = false
                this.showForm(0)
              })
              .catch(err => {
                if (err.response.data.errors === 'Unauthenticated') {
                  this.$router.push('login')
                }
                if (err.response.data.errors === 'Forbidden') {
                  this.$router.push('accessdeny')
                }
                this.error = err.message
                this.isLoadingSave = false
              })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Contracts/Contracts.vue